import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)
import tagHeader from './modules/tag-header/index.js';
import friendsList from './modules/friends-list/index.js';
import dodgeBallHeader from './modules/dodgeball-header/index.js';
import fruitsHeader from './modules/fruits-header/index.js';
import chat from './modules/chat/index.js';
import market from './modules/market/index.js';
import arcade from './modules/arcade/index.js';
import clowder from './modules/clowder/index.js';
import fish from './modules/fish/index.js';
import cave from './modules/cave/index.js';
import item from './modules/item/index.js';
import school from './modules/school/index.js';
import jobs from './modules/jobs/index.js';
import guidedTutorial from './modules/guided-tutorial/index.js';
import npc from './modules/npc.js';
import event from './modules/event.js';
import moment from 'moment';

const isLocal = (location.hostname.indexOf("localhost") > -1 || location.hostname.indexOf("localmeow") > -1) ? true : false;
const isDev = location.hostname.indexOf("meowthecatpet") > -1 || isLocal ? true : false;

const isMobile = "ontouchstart" in document.documentElement ? true : false;
const platform = function () {
    if(window.navigator.userAgent.indexOf("Steam") > -1)
        return "STEAM";
    else if(window.navigator.userAgent.indexOf("MeowPlayground") > -1)
        return "MOBILE_APP";
    else if(isMobile)
        return "MOBILE_BROWSER";
    else
        return "DESKTOP_BROWSER";
}();

export const store = new Vuex.Store({
    modules: {
        tagHeader,
        dodgeBallHeader,
        chat,
        market,
        arcade,
        clowder,
        npc,
        "friends": friendsList,
        fruitsHeader,
        fish,
        item,
        cave,
        school,
        jobs,
        guidedTutorial,
        event
    },
    state: {
        musicIsEnabled: localStorage.getItem("disableMusic") == "true" ? false : true,
        showWorld: false,
        isLocal: isLocal,
        isDev: isDev,
        openTown: 0,
        closeTown: 0,
        resizeChat: 0,
        applicationLoaded: 0,
        userConnected: false,
        modals: {
            showInventory: false,
            showVendor: false
        },
        socket: null,
        rooms: [],
        modalWindow: {
            title: "",
            size:"xl",
            shown: false,
            type: null
        },
        modalMessage: {
            message: "",
            title: ""
        },
        user: {
            id: 0,
            name: "",
            evenrgy: 0,
            lastEnergyRefill: null,
            profile: null,
            inventoryList: null,
            appearOffline: false,
            effects: [],
            items: [],
            looks:{
                skin: null,
                skinColor: null,
                glasses: null,
                companion: null,
                wings: null,
                hat: null,
                costume: null,
                mask: null,
                eyes: null,
            }
        },
        collectionsList: [],
        levelAwards: [],
        profileWindow: {
            id: 0,
            name: "",
            tagRanking: null,
            level: 0,
            coins: 0,
            diamonds: 0,
            memberSince: "",
            giftsSent: 0,
            gifts: [],
            clowder: null,
            personalRoom: null,
            currentRoom: null,
            type: null,
            authType: null,
            isVIP: false,
            isIgnored: false
        },
        banUser: null,
        settings: {
            disableGiftPopup: localStorage.getItem("disableGiftPopup") == 'true' ? true : false,
            textColor: "black",
            screenRatio: 1,
            chatViewAll: localStorage.getItem("chatViewAll") == 'true' ? true : false,
            antialias: localStorage.getItem("antialias") == "true" ? true : false,
            centeredWalk: localStorage.getItem("centeredWalk") == "true" ? true : false,
            notifications: localStorage.getItem("notifications") == "false" ? false : true,
            audio: {
                allSoundsDisabled: localStorage.getItem("disableMusic") == "true" ? true : false,
                minigameMusicVolume: localStorage.getItem("minigameMusicVolume") === null ? 70 : Number(localStorage.getItem("minigameMusicVolume") ),
                soundsVolume: localStorage.getItem("soundsVolume") === null ? 70 : Number(localStorage.getItem("soundsVolume") ),
                roomMusicVolume: localStorage.getItem("roomMusicVolume") === null ? 70 : Number(localStorage.getItem("roomMusicVolume") ),
            },
            allowSounds: localStorage.getItem("disableMusic") == "true" ? false : true,

            alwaysRun: localStorage.getItem("alwaysRun") == "true" ? true : false,
            maxFPS: localStorage.getItem("maxFPS") ?? 0,
            chatBubbles: localStorage.getItem("chatBubbles") === null  || localStorage.getItem("chatBubbles")  === "true" ? true : false,
            bgAnimations:  localStorage.getItem("bgAnimations") === null  || localStorage.getItem("bgAnimations")  === "true" ? true : false,
            fwAnimations:  localStorage.getItem("fwAnimations") === null  || localStorage.getItem("fwAnimations")  === "true" ? true : false,
            resolution: localStorage.getItem("resolution") ?? (platform === "DESKTOP_BROWSER" ? "limited" : "high"),
        },
        isRoomDesignMode: false,
        activeRoomData: {
            online: 0,
            name: "",
            furniture: [],
            enemies: []
        },
        stickyMsg: null,
        baseURL:  (() => {
            if (isLocal)
                return "//localhost:5443";
            else if (isDev)
                return "https://beta.meowthecatpet.com";
            else
                return "https://www.meowplayground.com";
        })(),
        isMobile: isMobile,
        platform: platform,
        shops:{

        },
        
    },
    getters: {
        isRoomDesignMode(state) { return state.isRoomDesignMode; },
        profileWindow(state) { return state.profileWindow},
        platform(state) { return state.platform},
        isMobile(state) { return state.isMobile},
        collectionsList(state) { return state.collectionsList},
        musicIsEnabled(state) { return state.musicIsEnabled  },
        isLocal(state) { return state.isLocal; },
        isDev(state) { return state.isDev; },
        baseURL(state) { return state.baseURL; },
        showWorld(state) { return state.showWorld; },
        modals(state) {return state.modals;},
        settings(state) {return state.settings;},
        resizeChat(state) { return state.resizeChat;},
        applicationLoaded(state) { return state.applicationLoaded;},
        userConnected(state) { return state.userConnected;},
        shops(state) { return state.shops;},
        isStaff(state) { return (state.user.type === 'ADMIN' || state.user.type === 'SUPERVISOR' || state.user.type === 'HELPER') ? true : false; },
        rooms(state) {
            return state.rooms;
        },
        activeRoomData(state) {
            return state.activeRoomData;
        },
        user(state) {
            return state.user;
        },
        banUser(state) {
            return state.banUser;
        },
        socket(state) {
            return state.socket;
        },
        modalWindow(state) {
            return state.modalWindow;
        },
        modalMessage(state) {
            return state.modalMessage;
        },
        stickyMsg(state) {
            return state.stickyMsg;
        },
        openTown(state) {return state.openTown;},
        closeTown(state) {return state.closeTown;},
        levelAwards(state) {
            return state.levelAwards;
        }
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        setSetting(state, data) {
            state.settings[data[0]] = data[1];
        },     
        setUser(state, data) {
            state.user = data;
        },
        setUserEffects(state, data) {
            state.user.effects = data;
        },
        banUser(state, data) {
            state.banUser = data;
        },
        updateUser(state, data) {
            for (let idx of Object.keys(data)) {
                Vue.set(state.user, idx, data[idx]);
            }
        },
        updateUserOutfit(state, data) {
            for (let idx of Object.keys(data)) {
                if(typeof state.user.looks[idx] !== "undefined")
                    Vue.set(state.user.looks, idx, data[idx]);
            }
        },
        modalMessage(state, data) {
            Vue.set(state, "modalMessage", {
                message: data[0],
                title: data[1] || ""
            });
        },
        resizeChat(state) {
            state.resizeChat++;
        },
        applicationLoaded(state) { state.applicationLoaded++; },
        userConnected(state, val) { state.userConnected = val },
        openTown(state) { state.openTown++; },
        closeTown(state) { state.closeTown++; },
        disableMusic(state, val) {
            state.settings.audio.allSoundsDisabled = val;
            state.musicIsEnabled = !val 
        },
        itemAdded(state, data){
            if(state.user[data.id])
                state.user.items[data.id].quantity++;
            else{
                state.user.items[data.id]= {
                    item_id: data.id,
                    quantity: data.amount
                }
            }
            state.user.items = {...state.user.items};
        },
        setShopItems(state, data){
            Vue.set(state.shops, data.shopID, data.items);
        },
        setProfile(state, data) {
            state.profileWindow = data;
            state.profileWindow.memberSince = moment(data.memberSince).fromNow();
        },
        giftSent(state, data) {
            let existingGift = state.profileWindow.gifts.find(g => g.id === data.id);
            if(existingGift)
                existingGift.quantity++;
            else
                state.profileWindow.gifts.push({id: data.id, name: data.name, quantity: 1, preview_loc: data.preview_loc});
        }
    },
    actions: {
        itemAdded({ commit }, val) {
            commit('itemAdded', val);
        },
        disableMusic({ commit }, val) {
            commit('disableMusic', val);
        },
        banUser({ commit }, data) {
            commit('banUser', data);
        },
        setValue({ commit }, data) {
            commit('setValue', data);
        },
        setSetting({ commit }, data) {
            commit('setSetting', data);
        },        
        setUser({ commit }, data) {
            commit('setUser', data);
        },
        updateUser({ commit }, data) {
            commit('updateUser', data);
        },
        updateUserOutfit({ commit }, data) {
            commit('updateUserOutfit', data);
        },
        setUserEffects({ commit }, data) {
            commit('setUserEffects', data);
        },
        modalMessage({ commit }, data) {
            commit('modalMessage', data);
        },
        applicationLoaded({ commit }, data) { commit('applicationLoaded', data); },
        userConnected({ commit }, data) { commit('userConnected', data); },
        resizeChat({ commit }, data) { commit('resizeChat', data); },
        openTown({ commit }, data) { commit('openTown', data); },
        closeTown({ commit }, data) { commit('closeTown', data); },
        setShopItems({ commit }, data) { commit('setShopItems', data); },
        setProfile({ commit }, data) { commit('setProfile', data); },
        giftSent({ commit }, data) { commit('giftSent', data); },
        userCollectLevelAward({ state, commit }, data) { state.socket.emit('user/level_award' , {
            awardId: data.awardId,
        }); }
    }
});